import { Button, Input, Modal, Tabs } from "antd";

const items = [
  {
    key: "1",
    label: "Your Domain",
    children: (
      <div
        className="d-flex align-items-center mt10"
        style={{ padding: "15px 24px 20px 24px", gap: 10, marginBottom: 60 }}
      >
        https://{" "}
        <Input
          placeholder="Domain Name"
          style={{ padding: "5px 11px" }}
          className="link-input"
        />{" "}
        /{" "}
        <Input
          placeholder="Slug"
          style={{ padding: "5px 11px" }}
          className="link-input"
        />
      </div>
    ),
  },
  {
    key: "2",
    label: "{Company Name} Default Domain",
    children: "{Company Name} Default Domain",
  },
];

const PublishLink = ({ handleCancel, isPublish }) => {
  return (
    <div>
      <Modal
        title={null}
        className="publish-link-popup"
        open={isPublish}
        centered
        closable={false}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <>
          <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
            Publish link
          </div>
          <div className="web-to-lead">
            <Tabs defaultActiveKey="1" items={items} onChange={() => {}} />
          </div>

          <div
            style={{
              padding: "15px 24px 20px 24px",
              borderTop: "0.20000000298023224px solid #e2e2e2",
            }}
            className="web-to-lead"
          >
            <div
              className="d-flex justify-content-end align-items-center"
              style={{ gap: 20 }}
            >
              <Button className="secondary-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" className="theme-btn">
                Publish
              </Button>
            </div>
          </div>
        </>
      </Modal>
    </div>
  );
};

export default PublishLink;
